module.exports = __webpack_public_path__ + "static/media/F06A080D-CA18-4956-9705-4B9306DC062A-min.b3eae50d.jpg";